import {
  BooleanParam,
  DateTimeParam,
  QueryParamConfigMap,
  StringParam,
} from 'common/hooks/customSearchParams';

export const ERL_STOP_THE_CLOCK_PARAMS: QueryParamConfigMap = {
  shippingLine: StringParam,
  containerType: StringParam,
  forDatetime: DateTimeParam,
  showCurrentShiftOnly: BooleanParam,
};
